import {
  PersonIdentityCode,
  RelatedPersonRelationship,
} from '@quromedical/fhir-common';
import { z } from 'zod';
import { UUIDSchema } from '../domain/models';
import type { PaginatedBundle } from '../domain/schema';
import { GenderSchema, GeneralSchema } from '../person/schema';
import {
  type BaseCreateRelatedPerson,
  BaseCreateRelatedPersonSchema,
  type BasePartialRelatedPerson,
  BasePartialRelatedPersonSchema,
  type BaseRelatedPerson,
  BaseRelatedPersonGetAllResponseSchema,
  type BaseRelatedPersonGetResponse,
  BaseRelatedPersonGetResponseSchema,
  BaseRelatedPersonSchema,
} from '../shared/person-types';

// Re-export the schemas from shared types
export const RelatedPersonSchema = BaseRelatedPersonSchema;
export type RelatedPerson = BaseRelatedPerson;

export const CreateRelatedPersonSchema = BaseCreateRelatedPersonSchema;
export type CreateRelatedPerson = BaseCreateRelatedPerson;

export const PartialRelatedPersonSchema = BasePartialRelatedPersonSchema;
export type PartialRelatedPerson = BasePartialRelatedPerson;

export const RelatedPersonGetResponseSchema =
  BaseRelatedPersonGetResponseSchema;
export type RelatedPersonGetResponse = BaseRelatedPersonGetResponse;

export const RelatedPersonGetAllResponseSchema =
  BaseRelatedPersonGetAllResponseSchema;
export interface RelatedPersonGetAllResponse extends PaginatedBundle {
  relatedPersons: RelatedPersonGetResponse[];
}

// Additional schemas specific to related-person
export const RelatedPersonWithIdSchema = RelatedPersonSchema.extend({
  id: z.string().uuid(),
});

// For RelatedPerson it is different because NOK through medical aid will have all detail, while private NOK only some.
export const RelatedPersonUpdateSchema = z.object({
  id: UUIDSchema,
  general: GeneralSchema.pick({
    prefixName: true,
    givenName: true,
    familyName: true,
  }).extend({
    gender: GenderSchema.optional(),
    birthDate: z.string().optional(),
    identifierCode: z.nativeEnum(PersonIdentityCode).optional(),
    identifierValue: z.string().optional(),
  }),
});

export type RelatedPersonUpdate = z.infer<typeof RelatedPersonUpdateSchema>;

export const RelatedPersonSearchParamsSchema = z.object({
  patient: z.string().uuid().optional(),
  name: z.string().optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  relationship: z.nativeEnum(RelatedPersonRelationship).optional(),
});

export type RelatedPersonSearchParams = z.infer<
  typeof RelatedPersonSearchParamsSchema
>;
